import React from "react";
import {
  Grid,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import { PhotoUploaderStyles } from "./PhotoUploaderStyles";
import PhotosUploadUtil, { truncateFileName } from "./PhotosUploadUtil";
import CloseIcon from "@material-ui/icons/Close";
import "./photosstyle.css";
import {
  FILE_SIZE_ERROR,
  FILE_TYPE_ERROR,
  MAX_ALLOWED_PHOTO_SIZE_IN_MB,
} from "../constants/GlobalConstants";

export const FrontDriver = (props: any) => {
  const classes = PhotoUploaderStyles();
  const [imgFDSPreview, setImgFDSPreview] = React.useState(undefined);
  const [imgFPSPreview, setImgFPSPreview] = React.useState(undefined);
  const [imgFDSPreviewName, setImgFDSPreviewName] = React.useState(undefined);
  const [imgFPSPreviewName, setImgFPSPreviewName] = React.useState(undefined);
  const [fdsError, setFDSError] = React.useState(undefined);
  const [fpsError, setFPSError] = React.useState(undefined);
  const [fdsErrorMessage, setFDSErrorMessage] = React.useState(FILE_SIZE_ERROR);
  const [fpsErrorMessage, setFPSErrorMessage] = React.useState(FILE_SIZE_ERROR);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  const handleEvent = (e) => {
    console.log(e.target.id);
    if (e.target.files.length > 1) {
      // setError("Error");
    } else {
      let fileInfoArr = [];
      const selected = e.target.files[0];
      let selectedFile = e.target.files[0];
      const selectID = e.target.id;
      console.log(selected.name);
      if (selectID === "drop_fds_bt") {
        setFDSError(false);
      } else if (selectID === "drop_fps_bt") {
        setFPSError(false);
      }
      let selectedFileSize = selected.size / 1024 / 1024; // in MB
      const ALLOWED_TYPES = ["image/jpeg", "image/jpg"];
      let image = new Image();
      if (
        selected &&
        ALLOWED_TYPES.includes(selected.type) &&
        selectedFileSize <= MAX_ALLOWED_PHOTO_SIZE_IN_MB
      ) {
        console.log("Selected");
        let reader = new FileReader();
        console.log(selected.ALLOWED_TYPES);
        reader.onloadend = () => {
          console.log("File Width " + selected.naturalWidth);
          console.log("File Height " + selected.naturalHeight);
          if (reader !== null && typeof reader.result == "string") {
            image.src = reader.result;
          }
          image.onload = () => {
            const width = image.width;
            const height = image.height;
            console.log("image Width" + width + "X" + height);
            if (width < 800 || height < 600) {
              selectedFile = PhotosUploadUtil(height, width, image, selected);
            } else {
              selectedFile = selected;
            }
            if (selectID === "drop_fds_bt") {
              setImgFDSPreview(reader.result);
              selectedFile.imageLabel = "Driver Side Front";
              selectedFile.additionalDescription = "Driver Side Front";
              selectedFile.imageDisplayFileName = selected.name;
              setImgFDSPreviewName(selected.name);
            } else if (selectID === "drop_fps_bt") {
              setImgFPSPreview(reader.result);
              selectedFile.imageLabel = "Passenger Side Front";
              selectedFile.additionalDescription = "Passenger Side Front";
              selectedFile.imageDisplayFileName = selected.name;
              setImgFPSPreviewName(selected.name);
            }
            fileInfoArr.push(selectedFile);
            props.updatePhotoFile(selectedFile);
            console.log(fileInfoArr.length);
          };
        };

        reader.readAsDataURL(selected);
      } else if (selectedFileSize > MAX_ALLOWED_PHOTO_SIZE_IN_MB) {
        console.log("Error: File size is more than 10 MB");
        if (selectID === "drop_fds_bt") {
          setFDSErrorMessage(FILE_SIZE_ERROR);
          setFDSError(true);
        } else if (selectID === "drop_fps_bt") {
          setFPSErrorMessage(FILE_SIZE_ERROR);
          setFPSError(true);
        }
      } else {
        console.log("Error: File not supported");
        if (selectID === "drop_fds_bt") {
          setFDSErrorMessage(FILE_TYPE_ERROR);
          setFDSError(true);
        } else if (selectID === "drop_fps_bt") {
          setFPSErrorMessage(FILE_TYPE_ERROR);
          setFPSError(true);
        }
      }
    }
  };

  function dragOverHandler(ev) {
    console.log("File(s) in drop zone");
    ev.preventDefault();
  }

  // fps setting for drag
  function fpsDropHandler(ev) {
    ev.preventDefault();
    if (ev.dataTransfer.items[0].kind === "file") {
      setFPSError(false);
      let image = new Image();
      const selected = ev.dataTransfer.items[0].getAsFile();
      let selectedFile = ev.dataTransfer.items[0].getAsFile();
      let selectedFileSize = selected.size / 1024 / 1024; // in MB

      const ALLOWED_TYPES = ["image/jpeg", "image/jpg"];
      if (selected && ALLOWED_TYPES.includes(selected.type)) {
        console.log("Selected");
        let reader = new FileReader();
        console.log(selected.ALLOWED_TYPES);
        if (selectedFileSize > MAX_ALLOWED_PHOTO_SIZE_IN_MB) {
          setFPSError(true);
          setFPSErrorMessage(FILE_SIZE_ERROR);
          return;
        }
        reader.onloadend = () => {
          if (reader !== null && typeof reader.result == "string") {
            image.src = reader.result;
          }
          image.onload = () => {
            const width = image.width;
            const height = image.height;
            console.log("image Width" + width + "X" + height);
            if (width < 800 || height < 600) {
              selectedFile = PhotosUploadUtil(height, width, image, selected);
            } else {
              selectedFile = selected;
            }
            setImgFPSPreview(reader.result);
            selectedFile.imageLabel = "Passenger Side Front";
            selectedFile.additionalDescription = "Passenger Side Front";
            selectedFile.imageDisplayFileName = selected.name;
            setImgFPSPreviewName(selected.name);
            props.updatePhotoFile(selectedFile);
          };
        };
        reader.readAsDataURL(selected);
      } else {
        setFPSError(true);
        setFPSErrorMessage(FILE_TYPE_ERROR);
      }
    }
  }

  // fds setting for drag
  function fdsDropHandler(ev) {
    ev.preventDefault();
    if (ev.dataTransfer.items[0].kind === "file") {
      setFDSError(false);
      let image = new Image();
      const selected = ev.dataTransfer.items[0].getAsFile();
      let selectedFile = ev.dataTransfer.items[0].getAsFile();
      let selectedFileSize = selected.size / 1024 / 1024; // in MB
      const ALLOWED_TYPES = ["image/jpeg", "image/jpg"];
      if (selected && ALLOWED_TYPES.includes(selected.type)) {
        console.log("Selected");
        if (selectedFileSize > MAX_ALLOWED_PHOTO_SIZE_IN_MB) {
          setFDSError(true);
          setFDSErrorMessage(FILE_SIZE_ERROR);
          return;
        }
        let reader = new FileReader();
        console.log(selected.ALLOWED_TYPES);
        reader.onloadend = () => {
          if (reader !== null && typeof reader.result == "string") {
            image.src = reader.result;
          }
          image.onload = () => {
            const width = image.width;
            const height = image.height;
            console.log("image Width" + width + "X" + height);
            if (width < 800 || height < 600) {
              selectedFile = PhotosUploadUtil(height, width, image, selected);
            } else {
              selectedFile = selected;
            }
            setImgFDSPreview(reader.result);
            selectedFile.imageLabel = "Driver Side Front";
            selectedFile.additionalDescription = "Driver Side Front";
            selectedFile.imageDisplayFileName = selected.name;
            setImgFDSPreviewName(selected.name);
            props.updatePhotoFile(selectedFile);
          };
        };
        reader.readAsDataURL(selected);
      } else {
        setFDSError(true);
        setFDSErrorMessage(FILE_TYPE_ERROR);
      }
    }
  }
  function deleteFDSFile() {
    setImgFDSPreview(null);
    props.deleteFDSFile();
  }
  function deleteFPSFile() {
    setImgFPSPreview(null);
    props.deleteFPSFile();
  }
  function deleteFDSErrorFile() {
    setFDSError(false);
  }
  function deleteFPSErrorFile() {
    setFPSError(false);
  }

  function onFPSFileSelectClick() {
    try {
      let elm = document.getElementById("drop_fps_bt");
      elm.click();
    } catch {}
  }

  function onFDSFileSelectClick() {
    try {
      let elm = document.getElementById("drop_fds_bt");
      elm.click();
    } catch {}
  }
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} className={classes.photoSelectInfo}>
        <Typography className={classes.photoSelectInfo}>
          Photos of Your Vehicle
        </Typography>
      </Grid>
      <Grid container item xs={12} md={6} className={classes.vehInfoDetails}>
        <Typography className={classes.photoInfoDetails}>
          Front Driver Side
        </Typography>
        <Grid
          xs={12}
          item
          className={classes.dropZone}
          id="drop_zone"
          data-testid={"drop_zone_front"}
          onDrop={fdsDropHandler}
          onDragOver={dragOverHandler}
          onClick={onFDSFileSelectClick}
        >
          {!fdsError ? (
            !imgFDSPreview ? (
              <>
                <Grid className={classes.container}>
                  <Grid container alignItems="center">
                    <Grid item xs={3} sm={12}>
                      <input
                        type="file"
                        id="drop_fds_bt"
                        data-testid={"drop_fds_bt"}
                        className="fileUpload"
                        style={{ display: "none" }}
                        accept=".jpeg,.jpg"
                        onChange={handleEvent}
                      />

                      <span
                        className={classes.icon + " icon-car-driver-front"}
                      ></span>
                    </Grid>
                    <Grid item xs={9} sm={12}>
                      <label className={classes.regularText}>
                        {"Drag & drop a file here or click to select a file"}
                      </label>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            ) : (
              <Grid style={{ textAlign: "center" }}>
                <Grid container>
                  <Grid item xs={2} md={5}>
                    <img
                      id="clickImg2"
                      src={imgFDSPreview}
                      className={
                        isMobile
                          ? classes.imagePreviewMobile
                          : classes.imagePreview
                      }
                      alt=""
                    />
                  </Grid>
                  <Grid item xs={8} md={5} className={classes.imagePrevName}>
                    <Typography className={classes.imageName}>
                      {truncateFileName(imgFDSPreviewName)}
                    </Typography>
                  </Grid>
                  <Grid item xs={2} style={{ alignContent: "center" }}>
                    <Button
                      color="default"
                      data-testid={"delete_drivers"}
                      startIcon={<CloseIcon />}
                      onClick={() => deleteFDSFile()}
                      className={classes.rightButton}
                    />
                  </Grid>
                </Grid>
              </Grid>
            )
          ) : (
            <Grid
              style={{
                textAlign: "center",
                paddingRight: "30px",
                paddingLeft: "30px",
              }}
            >
              <Grid container>
                <Grid container item xs={11} style={{ padding: "1rem" }}>
                  <Grid item xs={10} md={6} style={{ alignContent: "center" }}>
                    <span
                      className="icon-no-image"
                      style={{
                        fontSize: "45px",
                        color: "#8A0200",
                      }}
                    ></span>
                  </Grid>
                  <Grid item xs={10} md={6}>
                    <label className={classes.errorText}>
                      {fdsErrorMessage}
                      <br />
                      <br /> Please select another photo.
                    </label>
                  </Grid>
                </Grid>

                <Grid container item alignContent="center" xs={1}>
                  <Button
                    color="default"
                    startIcon={<CloseIcon />}
                    onClick={() => deleteFDSErrorFile()}
                    className={classes.rightButton}
                    data-testid={"delete_drivers_error"}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>

      <Grid container item xs={12} md={6} className={classes.vehInfoDetails}>
        <Typography className={classes.photoInfoDetails}>
          Front Passenger Side
        </Typography>
        <Grid
          item
          xs={12}
          className={classes.dropZone}
          id="drop_zone"
          data-testid={"drop_zone_passenger"}
          onDrop={fpsDropHandler}
          onDragOver={dragOverHandler}
          onClick={onFPSFileSelectClick}
        >
          {!fpsError ? (
            !imgFPSPreview ? (
              <Grid className={classes.container}>
                <Grid container alignItems="center">
                  <Grid item xs={3} sm={12}>
                    <input
                      type="file"
                      id="drop_fps_bt"
                      className="fileUpload"
                      style={{ display: "none" }}
                      accept=".jpeg,.jpg"
                      onChange={handleEvent}
                      data-testid={"drop_fps_bt"}
                    />

                    <span
                      className={classes.icon + " icon-car-passenger-front"}
                    ></span>
                  </Grid>
                  <Grid item xs={9} sm={12}>
                    <label className={classes.regularText}>
                      {"Drag & drop a file here or click to select a file"}
                    </label>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <Grid style={{ textAlign: "center" }}>
                <Grid container>
                  <Grid item xs={2} md={5}>
                    <img
                      id="clickImg2"
                      src={imgFPSPreview}
                      className={
                        isMobile
                          ? classes.imagePreviewMobile
                          : classes.imagePreview
                      }
                      alt=""
                    />
                  </Grid>
                  <Grid item xs={8} md={5} className={classes.imagePrevName}>
                    <Typography className={classes.imageName}>
                      {truncateFileName(imgFPSPreviewName)}
                    </Typography>
                  </Grid>
                  <Grid item xs={2} style={{ alignContent: "center" }}>
                    <Button
                      color="default"
                      startIcon={<CloseIcon />}
                      data-testid={"delete_passenger"}
                      onClick={() => deleteFPSFile()}
                      className={classes.rightButton}
                    />
                  </Grid>
                </Grid>
              </Grid>
            )
          ) : (
            <Grid
              style={{
                textAlign: "center",
                paddingRight: "30px",
                paddingLeft: "30px",
              }}
            >
              <Grid container>
                <Grid container item xs={11} style={{ padding: "1rem" }}>
                  <Grid item xs={10} md={6} style={{ alignContent: "center" }}>
                    <span
                      className="icon-no-image"
                      style={{
                        fontSize: "45px",
                        color: "#8A0200",
                      }}
                    ></span>
                  </Grid>
                  <Grid item xs={10} md={6}>
                    <label className={classes.errorText}>
                      {fpsErrorMessage}
                      <br />
                      <br /> Please select another photo.
                    </label>
                  </Grid>
                </Grid>

                <Grid container item alignContent="center" xs={1}>
                  <Button
                    color="default"
                    startIcon={<CloseIcon />}
                    onClick={() => deleteFPSErrorFile()}
                    className={classes.rightButton}
                    data-testid={"delete_passenger_error"}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
export default FrontDriver;
